import { ListItem, ListItemSuffix } from '@material-tailwind/react';
import { ChevronDown } from 'lucide-react';
import React, { useState } from 'react';
import { TableLocaisApc } from '../Main/TableLocaisApc';

const ListItemApc = ({ array, title }) => {
  const [table, setTable] = useState(false);

  const handlTable = () => {
    setTable(!table);
  };
  return (
    <>
      <ListItem
        onClick={handlTable}
        className="p-2 m-0  flex  dark:text-white focus:text-black  items-center border border-black focus:border-black active:border-black   rounded-md shadow-sm shadow-black dark:bg-darkButtonColor bg-lightButtonColor text-black focus:bg-lightButtonColor w-full"
      >
        {title}
        <ListItemSuffix>
          <ChevronDown className="h-4 w-4" />
        </ListItemSuffix>
      </ListItem>
      {table && <TableLocaisApc array={array} />}
    </>
  );
};

export default ListItemApc;
